import FormViewForm from '@src/components/_forms/FormViewForm';
import ChecklistItemsField from './fields/ChecklistItemsField';
import {IChecklistModel} from '@src/@interfaces/models/Checklist/IChecklistModel';
import ChecklistStatusSettingsField from '@views/checklists/fields/ChecklistStatusSettingsField';

const customFields = {
    items: {
        component: ChecklistItemsField,
    },
    status_settings: {
        component: ChecklistStatusSettingsField,
    },
};

export default class ChecklistForm<Model extends IChecklistModel> extends FormViewForm<Model> {
    protected get customFields() {
        return customFields;
    }

    protected mutateModelFieldInitialValue(fieldName: string, modelValue: any): any {
        if (fieldName === 'items') {
            return this.getItemsFieldInitialValue();
        }

        if (fieldName === 'status_settings') {
            return this.getStatusSettingsFieldInitialValue();
        }

        return super.mutateModelFieldInitialValue(fieldName, modelValue);
    }

    private getItemsFieldInitialValue() {
        return this.props.model?.items?.map(item => ({
            id: item.id,
            title: item.title,
            is_order_completely_payed_item: item.is_order_completely_payed_item,
        }));
    }

    private getStatusSettingsFieldInitialValue() {
        return this.props.model?.status_settings?.map(item => ({
            id: item.id,
            display_when: item.display_when_id,
            change_to: item.change_to_id,
        }));
    }
}
